<div [ngClass]="{'content-overlay' : isModal}">
    <div class="single" id="single-form">
        <form [formGroup]="form" (ngSubmit)="save()" method="post" *ngIf="isInitialized">
            <div class="form__container">
                <p class="infobox empty-data" *ngIf="entity.is_default">
                    <span class="ico-info frown"></span> Toto je defaultní agent, pokud nebude jiný agent vyplněn u nemovitosti nebo developerského projektu, bude použit tento.
                </p>
            </div>
            <swb-form-fields [fields]="formEditors" [form]="form"></swb-form-fields>
            <div class="align-right">
                <button type="submit" class="cta cta--blue submit" [ngClass]="{'submit--submitting': isSaving}"
                    [disabled]="isSaving">
                    <i class="ico-save"></i> Uložit</button>
            </div>
        </form>
        <div *ngIf="!isInitialized" class="loading loading--padding loading--white"></div>
    </div>
</div>